import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import styles from 'components/Shared/FilesPreviewDialog/FilesPreviewDialog.module.css'
import IconButton from '@material-ui/core/IconButton'
import { ReactComponent as NextIcon } from 'assets/icons/right.svg'
import { ReactComponent as PrevIcon } from 'assets/icons/left.svg'
import { ReactComponent as DownloadIcon } from 'assets/icons/add.svg'
import { ReactComponent as PDFIcon } from 'assets/icons/pdf.svg'
import { ReactComponent as ExitIcon } from 'assets/icons/exit.svg'
import { Loader } from 'components/Shared/Loader'
import { useErrorHandling } from 'context/errorHandling'

const isImage = require('is-image')

export function FilesPreviewDialog ({ open, files, onClose, fileToShow, filesSource, onFileChanged, children }) {
  const [img, setImg] = useState()
  const [pdfUrl, setPdfUrl] = useState()
  const [unknownTypeUrl, setUnknownTypeUrl] = useState()
  const [loading, setLoading] = useState(false)
  const [displayedFile, setDisplayedFile] = useState(null)

  const { handleError } = useErrorHandling()

  useEffect(() => {
    if (fileToShow && (!displayedFile || fileToShow.id !== displayedFile.id)) {
      setImg(null)
      setPdfUrl(null)
      setUnknownTypeUrl(null)
      setLoading(true)
      filesSource(fileToShow).then(response => {
        setDisplayedFile(fileToShow)
        setLoading(false)
        if (isImage(fileToShow.filename)) {
          const url = URL.createObjectURL(new Blob([response]))
          setImg(url)
        } else if (fileToShow.filename.endsWith('.pdf')) {
          const url = URL.createObjectURL(new Blob([response], { type: 'application/pdf' }))
          setPdfUrl(url)
        } else {
          setUnknownTypeUrl(URL.createObjectURL(new Blob([response])))
        }
      })
        .catch(handleError)

    }
  }, [fileToShow, filesSource, files, displayedFile, handleError])

  const next = () => {
    const nextFile = files[(files.indexOf(fileToShow) + 1) % files.length]
    onFileChanged(nextFile)
  }

  const previous = () => {
    const previousFile = files[(files.indexOf(fileToShow) - 1 + files.length) % files.length]
    onFileChanged(previousFile)
  }

  function download () {
    const url = img || pdfUrl || unknownTypeUrl
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileToShow.filename) //or any other extension
    document.body.appendChild(link)
    link.click()
  }

  return (<div>
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={false}
      fullWidth
    >
      <div className="row mt-3 mx-0">
        <div className="col-2"></div>
        <div className="col-8">
          <h2
            className={'text-center'}>
            {fileToShow?.filename}
          </h2>
        </div>
        <div className="col-2">
          <div className="row mr-3 mt-3">
            <div className="flex-grow-1"/>
            <DownloadIcon onClick={download}
                          className={styles.downloadIcon}/>
            <ExitIcon onClick={onClose}
                      className={styles.exitIcon}/>
          </div>
        </div>
      </div>
      <DialogContent className={styles.contentContainer}>

        <div
          className={'row w-100 h-100 align-items-center ' + styles.imageContent}>
          {loading && <Loader/>}
          <div className={'col-1'}>
            {files?.length > 1 && <IconButton className={styles.button}
                                              onClick={previous}><PrevIcon/></IconButton>}
          </div>
          <div className={'col-10'}>
            {img && !loading && <img className={'my-auto ' + styles.image} src={img}
                                     alt={'File'}/>}
            {pdfUrl && !loading && <IconButton className={'m-auto'}
                                               onClick={() => window.open(pdfUrl)}><PDFIcon
              className={styles.fileFormatIcon}/></IconButton>}
            {!pdfUrl && !loading && !img && <IconButton className={'m-auto'}
                                                        onClick={() => download()}><DownloadIcon
              className={styles.fileFormatIcon}/></IconButton>}
          </div>
          <div className={'col-1'}>
            {files && files.length > 1 && <IconButton className={styles.button}
                                                      onClick={next}><NextIcon/></IconButton>}
          </div>
        </div>
      </DialogContent>

      <DialogActions
        className={styles.dialogActions}
        disableSpacing>
        {children}
      </DialogActions>
    </Dialog>
  </div>)
}
